import KitLog from "../KitLog";
import {KitTrack} from "./KitTrack";
import {CacheManager} from "@/Fwk/Kit/Track/CacheManager";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class EData {
    private readonly id: number;
    readonly type: number;
    private text: string;
    private json: JsonData | null = null;
    private readonly indexName: number;

    constructor(id: number, type: number, text: string = "") {
        this.id = id;
        this.type = type;
        this.text = text;
        this.indexName = type * CacheManager.FILE_K + id;
    }

    SetText(jsonStr: string) {
        return this.text = jsonStr;
    }

    GetText(): string {
        if (this.text) return this.text;
        CacheManager.ReadStore(this);
        if (!KitLog.IsLog) return this.text;
        KitTrack.Log(`读取缓存-IndexName：${this.indexName}`);
        KitTrack.Log(`读取缓存-Text：${this.text}`);
        return this.text;
    }

    GetUpLoadJsonData(): JsonData {
        if (this.json != null) return this.json;
        const jsonStr = this.GetText();
        try {
            this.json = new JsonData(null, jsonStr);
        } catch (Exception) {
            this.json = new JsonData();
        }

        KitTrack.MergeBase(this.json);
        return this.json;
    }


    public BuildIndexName(): number {
        return this.indexName;
    }
}
